import { BUTTON_PRESS } from '@/utils/analytics'

/**
 * Analytics events fired by the Floor-plan header side-panel toggles.
 *
 * These consts intentionally resolve to the EXACT Mixpanel event names the
 * legacy header fires inline (`Button Press: Facility Checkpoints` /
 * `Button Press: Facility Tour Plans`) so the rebranded header (ENG-30683)
 * reports identically — the ticket requires all existing instrumentation to
 * keep firing unchanged. Properties (`facility_id`, `role`) are preserved too.
 */
export const FLOOR_PLAN_HEADER_ANALYTICS = {
  checkpointsPress: `${BUTTON_PRESS} Facility Checkpoints`,
  tourPlansPress: `${BUTTON_PRESS} Facility Tour Plans`,
} as const

/**
 * Analytics events fired by the Floor-plan header's Edit Mode toggle.
 *
 * The names are the ones the Side Bar toggle fired before Edit Mode moved into
 * this header, so existing Mixpanel reports keep resolving. Properties are the
 * header's standard `facility_id` / `role` pair — the Side Bar had no facility
 * context and sent placeholders — plus `is_entering` on `pressed`, which is the
 * only place the direction of a toggle is recorded.
 */
export const FLOOR_PLAN_EDIT_MODE_ANALYTICS = {
  pressed: 'Edit Mode Pressed',
  entered: 'Enters Edit Mode',
} as const

/**
 * Analytics events fired by the Checkpoints side panel.
 *
 * These consts intentionally resolve to the EXACT Mixpanel event names the
 * legacy panel fires inline via `mixpanel.track` so the rebranded panel
 * (ENG-32182) reports identically. Properties (`checkpoint_id`,
 * `facility_id`, `floor_id`, `role`, `selected_count`, `total_count`) are
 * preserved too.
 */
export const FLOOR_PLAN_CHECKPOINTS_ANALYTICS = {
  bulkPrintQrCodes: `${BUTTON_PRESS} Bulk Print Checkpoint QR Codes`,
  checkpointDetails: `${BUTTON_PRESS} Checkpoint Details`,
  checkpointDetailsEditCancel: `${BUTTON_PRESS} Checkpoint Details - Edit Cancel`,
  checkpointDetailsEditSave: `${BUTTON_PRESS} Checkpoint Details - Edit Save`,
  createCheckpoint: `${BUTTON_PRESS} Facility Checkpoints - Create Checkpoint`,
  mapCheckpointEndMoving: `${BUTTON_PRESS} Map Checkpoint - End Moving`,
  mapCheckpointMovePlacement: `${BUTTON_PRESS} Map Checkpoint - Move Placement`,
  mapCheckpointRemove: `${BUTTON_PRESS} Map Checkpoint - Remove from map - Remove`,
  mapCheckpointRemoveCancel: `${BUTTON_PRESS} Map Checkpoint - Remove from floor - Cancel`,
  printQrCodes: `${BUTTON_PRESS} Facility Checkpoints - Print QR Codes`,
} as const
